import { render, staticRenderFns } from "./TwIvPdfGoodsLineTable.vue?vue&type=template&id=59cdfd44&"
import script from "./TwIvPdfGoodsLineTable.vue?vue&type=script&lang=js&"
export * from "./TwIvPdfGoodsLineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports